import { Component, TemplateRef, ViewChild } from '@angular/core';

import { of } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import { ComponentInputComponent } from '@camelot/form-input';
import { InputComponent, InputDynamic, InputDynamicTranslation, CamAbstractInput, InputTranslation } from '@camelot/form-model';
import { CamDynamicTranslationsService } from '@camelot/services';

import { TestIdDirective } from '@camelot/testing-harness';

const dynamicTranslationsServiceMock = {
  fetchKeyForForm$: () => of({}),
};

@Component({
    imports: [ComponentInputComponent, FormComponent, TestIdDirective],
    providers: [{ provide: CamDynamicTranslationsService, useValue: dynamicTranslationsServiceMock }],
    template: `
    <cam-form camTestId="cam-form-extra" [inputs]="this.formInputs" />
    @if (this.componentInput) {
      <cam-input-component camTestId="cam-input-component" [input]="this.componentInput" [standalone]="true" />
    }
    <ng-template #componentTemplate>
      <div>component input template</div>
    </ng-template>
  `
})
export class FormExtraCase {
  @ViewChild('componentTemplate', { static: true })
  componentTemplate!: TemplateRef<any>;

  public componentInput: InputComponent | null = null;
  public formInputs: CamAbstractInput[] = [
    new InputDynamic({ key: 'dynamic', label: 'Dynamic' }),
    new InputTranslation({ key: 'translation', label: 'Translation' }),
    new InputDynamicTranslation({ dynamicKey: 'e2e.dynamic-key', key: 'dynamic-translation' }),
  ];

  ngOnInit(): void {
    this.componentInput = new InputComponent({ key: 'component', template: this.componentTemplate });
  }
}
